import styled from "styled-components";
import bitcoin from "../../assets/bitcoin.png";
import { BsQuestionCircle } from "react-icons/bs";
import { motion } from "framer-motion/dist/framer-motion";

export const MainTrendingNFTs = styled.div`
  overflow: hidden;
  margin-top: 80px;
`;

export const TrendingNFTsHeading = styled(motion.h2)`
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #1a1a1a;
  text-align: center;
`;

export const CardContainer = styled(motion.div)`
  margin: 40px 0px 80px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 80px;

  @media (max-width: 1199.98px) {
    gap: 40px;
  }

  @media (max-width: 991.98px) {
    display: flex;
    flex-direction: column;
  }

  .card {
    min-height: 320px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1))
      drop-shadow(-4px -4px 10px rgba(0, 0, 0, 0.1));
    overflow: hidden;

    &:hover .cardBtn {
      display: block;
    }
  }

  .card-img,
  .card-img-bottom,
  .card-img-top {
    &:hover {
      transform: scale(1.05, 1.03);
      transition: all 0.3s;
    }
  }

  .card-body {
    padding: 0;
  }

  .card-title {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0px 10px;
    margin-bottom: 0;
    z-index: 1;
  }

  .card-text:last-child {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 10px 0px;

    span {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #000000;
      padding: 10px 10px 5px 20px;
    }

    .img-fluid {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
`;

export const CardBtn = styled.button`
  display: none;
  justify-content: center;
  align-items: center;
  width: 80px;
  gap: 12px;
  background: rgb(230, 126, 34);
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  border: none;

  &:hover {
    background: rgb(230, 126, 34, 0.8);
  }
`;

export const HeaderText = styled.h2`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
`;

export const HeaderIcons = styled.div``;

export const BottomContainer = styled(motion.div)`
  background-image: url(${bitcoin});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  padding-bottom: 80px;
  margin-top: 40px;
`;

export const BottomHeader = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 47px;
  color: #000000;
  text-align: center;

  @media (max-width: 991.98px) {
    text-align: justify;
  }

  @media (max-width: 575.98px) {
    text-align: center;
  }
`;

export const TextWrapper = styled.div`
  margin-top: 40px;
  margin-left: 50px;

  @media (max-width: 991.98px) {
    margin-left: 0px;
    padding: 0px 10px;
  }
`;

export const BottomText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.05em;
  color: #111111;
  margin-top: 40px;
  text-align: center;

  @media (max-width: 991.98px) {
    text-align: justify;
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;

  @media (max-width: 575.98px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Question = styled(BsQuestionCircle)`
  font-size: 30px;
  margin-left: 40px;
  cursor: pointer;

  @media (max-width: 575.98px) {
    margin-top: 20px;
    margin-right: auto;
    margin-left: auto;
  }
`;
